import { PermissionEnum } from "./types";

export const checkPermissions = (
  userPermissions: string[] | undefined,
  required: PermissionEnum
) => {
  return userPermissions?.includes(required) ?? false;
};
